module.exports = __webpack_public_path__ + "assets/img/gar8-11.d43600d1.jpg";